import { useMemo } from 'react';

import { api, FctReport } from '@/api';
import { useUser } from '@/core/user';
import { useStudyGuard } from '@/shared/guard';

import { useUpdateFindingsStores } from './use-update-findings-stores.hook';

interface InitializeReport {
  isLoading: boolean;
  report?: FctReport;
}

export function useInitializeReport(): InitializeReport {
  const {
    patient: { gender },
    studyId,
  } = useStudyGuard();

  const { user } = useUser();

  const { data: report, isLoading: isLoadingReport } = api.fct.report.query.useGetReportStudy(
    { payload: { params: { patient_gender: gender, user_id: user.user_id }, studyId } },
    { enabled: Boolean(studyId && user.user_id && gender) },
  );

  const { isLoading: isLoadingRenderedSummaries } = useUpdateFindingsStores(report);

  const value = useMemo(
    () => ({ isLoading: isLoadingReport || isLoadingRenderedSummaries, report }),
    [isLoadingReport, isLoadingRenderedSummaries, report],
  );

  return value;
}
